import PropTypes from "prop-types";
import React from "react";
import { currencies } from "./currencies/currencies";

/** Must match handleChange: prepay → total → active asset; autopay → application → default asset */
function sliderAssetForTerm(term) {
  return term !== "total" ? "select-button-active.svg" : "select-button.svg";
}

export default function PlanSwitch(props) {
  const sliderAsset = sliderAssetForTerm(props.term);

  const handleChange = (name) => {
    if (name === "prepay") {
      props.updatePricingTerms("total");
    } else {
      props.updatePricingTerms("application");
    }
  };
  let currentCurrency = "$";
  const currency = currencies?.find(
    (currency) => currency.name === props.currency,
  );
  if (currency) {
    currentCurrency = currency.symbol;
  }

  const segmentStyle = {
    boxSizing: "border-box",
    flex: "1 1 0",
    minWidth: 0,
    maxWidth: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 4px",
    fontSize: 11,
    lineHeight: 1.25,
    textAlign: "center",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    cursor: "pointer",
    WebkitHyphens: "auto",
    hyphens: "auto",
  };

  // biome-ignore lint/suspicious/noGlobalIsNan: <explanation>
  return !isNaN(props.discount) &&
    props.autoPayAvailable &&
    props.prePayAvailable ? (
    <div
      style={{
        width: 349,
        maxWidth: "100%",
        minHeight: 63,
        boxSizing: "border-box",
        backgroundImage: `url(/assets/images/${sliderAsset})`,
        backgroundSize: "86% auto",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        justifyContent: "center",
        paddingLeft: 20,
        paddingRight: 20,
        fontFamily: `'Open Sans', sans-serif`,
      }}
    >
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <div
        onClick={() => {
          handleChange("autopay");
        }}
        style={segmentStyle}
      >
        {props.autoPayAlternativeLabel || "AUTOPAY"}
      </div>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <div
        onClick={() => {
          handleChange("prepay");
        }}
        style={segmentStyle}
      >
        PRE-PAY{" "}
        {props.discount.toFixed(2) >= 0.01
          ? `& SAVE ${currentCurrency}${props.discount.toFixed(2)}`
          : ""}
      </div>
    </div>
  ) : null;
}

PlanSwitch.propTypes = {
  updatePricingTerms: PropTypes.func,
};
